import LinkedClientsTable from './LinkedClientsTable';

export default LinkedClientsTable;


// WEBPACK FOOTER //
// ./src/features/reports/components/single-client-details/linked-clients-details/index.js